import { format } from "d3-format";
import React, { Component } from "react";
import PropTypes from "prop-types";
import displayValuesFor from "./displayValuesFor";
import GenericChartComponent from "../GenericChartComponent";

import { functor } from "../utils";

import ToolTipText from "./ToolTipText";
import ToolTipTSpanLabel from "./ToolTipTSpanLabel";

class StochasticTooltip extends Component {
  constructor(props) {
    super(props);
    this.renderSVG = this.renderSVG.bind(this);
  }
  renderSVG(moreProps) {
    const { onClick, fontFamily, fontSize, yAccessor, displayFormat, label } =
      this.props;
    const { className, options, appearance, labelFill } = this.props;
    const { displayValuesFor } = this.props;
    const {
      chartConfig: { width, height },
    } = moreProps;

    const currentItem = displayValuesFor(this.props, moreProps);
    const { stroke } = appearance || { stroke: {} };
    const stochastic = currentItem && yAccessor(currentItem);

    const K =
      (stochastic && stochastic.K && displayFormat(stochastic.K)) || "n/a";
    const D =
      (stochastic && stochastic.D && displayFormat(stochastic.D)) || "n/a";

    // Provide fallback values for options
    const windowSize = options.windowSize || 12;
    const kWindowSize = options.kWindowSize || 3;
    const dWindowSize = options.dWindowSize || 3;

    const { origin: originProp } = this.props;
    const origin = functor(originProp);
    const [x, y] = origin(width, height);

    return (
      <g
        className={className}
        transform={`translate(${x}, ${y})`}
        onClick={onClick}
        data-evo-id="tooltip-stochastic"
      >
        <ToolTipText x={0} y={0} fontFamily={fontFamily} fontSize={fontSize}>
          <ToolTipTSpanLabel
            fill={labelFill}
          >{`${label} %K(`}</ToolTipTSpanLabel>
          <tspan
            fill={stroke.kLine || "#ff7f0e"}
          >{`${windowSize}, ${kWindowSize}`}</tspan>
          <ToolTipTSpanLabel fill={labelFill}>): </ToolTipTSpanLabel>
          <tspan fill={stroke.kLine || "#ff7f0e"}>{K}</tspan>
          <ToolTipTSpanLabel fill={labelFill}> %D (</ToolTipTSpanLabel>
          <tspan fill={stroke.dLine || "#17becf"}>{dWindowSize}</tspan>
          <ToolTipTSpanLabel fill={labelFill}>): </ToolTipTSpanLabel>
          <tspan fill={stroke.dLine || "#17becf"}>{D}</tspan>
        </ToolTipText>
      </g>
    );
  }
  render() {
    return (
      <GenericChartComponent
        clip={false}
        svgDraw={this.renderSVG}
        drawOn={["mousemove"]}
      />
    );
  }
}

StochasticTooltip.propTypes = {
  origin: PropTypes.oneOfType([PropTypes.array, PropTypes.func]).isRequired,
  className: PropTypes.string,
  fontFamily: PropTypes.string,
  fontSize: PropTypes.number,
  labelFill: PropTypes.string,

  onClick: PropTypes.func,
  yAccessor: PropTypes.func.isRequired,
  options: PropTypes.shape({
    windowSize: PropTypes.number,
    kWindowSize: PropTypes.number,
    dWindowSize: PropTypes.number,
  }),
  appearance: PropTypes.shape({
    stroke: PropTypes.shape({
      dLine: PropTypes.string,
      kLine: PropTypes.string,
    }),
  }),
  displayFormat: PropTypes.func.isRequired,
  displayValuesFor: PropTypes.func,
  label: PropTypes.string.isRequired,
};

StochasticTooltip.defaultProps = {
  displayFormat: format(".2f"),
  displayValuesFor: displayValuesFor,
  origin: [0, 0],
  className: "react-stockcharts-tooltip",
  label: "STO",
  appearance: {
    stroke: {
      kLine: "#ff7f0e",
      dLine: "#17becf",
    },
  },
  options: {
    windowSize: 12,
    kWindowSize: 3,
    dWindowSize: 3,
  },
};

export default StochasticTooltip;
